import AuthService from "../../app/auth/Authorization.service";

// src/services/socket.ts
const { REACT_APP_AUTH_SERVER_BASE_URL } = process.env;

/**
 * Creates a WebSocket connection to the backend using the same base URL logic as Axios.
 * Automatically switches between ws:// and wss:// depending on the environment.
 */
export function connectSocket(mocktestId: string) {
    if (!REACT_APP_AUTH_SERVER_BASE_URL) {
        throw new Error('Missing environment variable: REACT_APP_AUTH_SERVER_BASE_URL');
    }

    // Replace http(s) with ws(s)
    const wsBaseUrl = REACT_APP_AUTH_SERVER_BASE_URL
    .replace(/^http/, 'ws') // transforms http:// -> ws:// or https:// -> wss://
    .replace(/\/+$/, '');   // remove trailing slashes

    const token = AuthService.getAccessToken();
    const socket = new WebSocket(`${wsBaseUrl}/ws?token=${token}`);
    socket.onopen = () => console.log("Connected");
    socket.onclose = () => console.log("Disconnected");
    return socket;
}
